export const isLevi = (teamId?: string): boolean =>
  teamId && teamId === process.env.REACT_APP_LEVI_TEAM_ID ? true : false
